import createSagaMiddleware from 'redux-saga';
import { captureException, createReduxEnhancer } from '@sentry/react';
import { configureStore } from '@reduxjs/toolkit';

import { rootReducer } from './root.reducer';
import { rootSaga } from '../sagas';
import paginationMiddleware from './middleware/paginationMiddleware';
import { listenerMiddleware } from './listenerMiddleware';

const sentryReduxEnhancer = createReduxEnhancer();

const sagaMiddleware = createSagaMiddleware({
    onError: (error) => {
        console.error(error);
        captureException(error);
    },
});

/**
 * Logs all actions and states after they are dispatched.
 */
const logger = (store: any) => (next: any) => (action: any) => {
    if (import.meta.env.REACT_APP_ENVIRONMENT === 'dev') {
        console.group(action.type);
        console.info('dispatching', action);
        const result = next(action);
        console.log('next state', store.getState());
        console.groupEnd();
        return result;
    } else {
        return next(action);
    }
};

const middleware = [sagaMiddleware, paginationMiddleware, logger];

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false })
            .prepend(listenerMiddleware.middleware)
            .concat(middleware),
    enhancers: (getDefaultEnhancers) =>
        getDefaultEnhancers().concat(sentryReduxEnhancer),
});
sagaMiddleware.run(rootSaga);

export default store;

export type AppDispatch = typeof store.dispatch;
